import { useState } from 'react'
import {
  Mtds,
  PlusIcon,
  ScreenHeader,
  ScreenLayout,
  TopBar,
  AppLayout,
  useGetProductsQuery
} from 'prove-common'
import { ProductsTable } from '../tables/products-table/ProductsTable'
import { AppLogo } from '../components/app-logo/AppLogo'
import { SideBarLayout } from '../components/side-bar-layout/SideBarLayout'
import { ProductForm } from '../components/reference-data/ReferenceEntityForms'
import { ReferenceQueryStatus } from '../components/reference-data/ReferenceQueryStatus'

export const ProductsScreen = () => {
  const [isModalOpen, setModalOpen] = useState(false)
  const { data: products, isFetching, isError, refetch } = useGetProductsQuery()
  return (
    <AppLayout
      useMobileBar={false}
      isFullWidth
      sidebar={<SideBarLayout />}
      topBar={<TopBar logo={<AppLogo />} title='Produkter' />}
    >
      <ScreenLayout
        header={
          <ScreenHeader
            title='Produkter'
            description='Produkter som sammen med matriser definerer prøvetypene.'
            actions={
              <Mtds.Button
                data-variant='primary'
                onClick={() => setModalOpen(true)}
              >
                <PlusIcon />
                Legg til produkt
              </Mtds.Button>
            }
          />
        }
      >
        <ReferenceQueryStatus
          hasData={products != null}
          isFetching={isFetching}
          isError={isError}
          refetch={refetch}
        />
        {products ? <ProductsTable products={products} /> : null}
      </ScreenLayout>
      {isModalOpen && <ProductForm onClose={() => setModalOpen(false)} />}
    </AppLayout>
  )
}
